import axiosInstance from "./axiosInstance";
import * as Endpoints from "../entities/Endpoints";

export const fetchTwilioToken = async (participantId) => {
  try {
    const response = await axiosInstance.get(
      `${Endpoints.CREATE_TOKEN}?participantId=${participantId}`
    );
    return response?.data;
  } catch (error) {
    console.error("Error fetching Twilio token:", error);
    throw error;
  }
};
